import { produce } from 'immer';
import { set } from 'lodash/fp';
import type { TypedReduxActionOutcomes } from 'app/store/storeTypes';
import { REHYDRATE } from 'app/store/types.js';
import {
    SAVE_DATA_GRID_PANEL_COLUMN_WIDTH,
    SAVE_EXPLORER_DATA_GRID_COLUMN_WIDTH,
    SAVE_METADATA_GRID_COLUMN_WIDTH,
    SAVE_DATA_PROFILE_COLUMN_WIDTH
} from './types';

export type ColumnWidthState = {
    dataGridPanel: Record<string, Record<string, number>>;
    explorerDataGrid: Record<string, Record<string, Record<string, number>>>;
    columnMetadataGrid: Record<string, Record<number, number>>;
    dataProfile: Record<string, number>;
};

export const INITIAL_STATE: ColumnWidthState = {
    dataGridPanel: {},
    explorerDataGrid: {},
    columnMetadataGrid: {},
    dataProfile: {}
};

export const columnWidthsReducer = produce((draft, action: TypedReduxActionOutcomes) => {
    switch (action.type) {
        case SAVE_DATA_GRID_PANEL_COLUMN_WIDTH: {
            const { entityId, columnName, width } = action.payload;

            draft.dataGridPanel = set([entityId, columnName], width, draft.dataGridPanel);
            break;
        }
        case SAVE_EXPLORER_DATA_GRID_COLUMN_WIDTH: {
            const { entityId, columnName, width, queryUuid } = action.payload;

            draft.explorerDataGrid = set(
                [entityId, queryUuid, columnName],
                width,
                draft.explorerDataGrid
            );
            break;
        }
        case SAVE_METADATA_GRID_COLUMN_WIDTH: {
            const { entityId, columnIndex, width } = action.payload;

            draft.columnMetadataGrid = set(
                [entityId, columnIndex],
                width,
                draft.columnMetadataGrid
            );
            break;
        }
        case SAVE_DATA_PROFILE_COLUMN_WIDTH: {
            const { entityId, width } = action.payload;

            draft.dataProfile = set([entityId], width, draft.dataProfile);
            break;
        }

        case REHYDRATE: {
            const { payload } = action;
            if ('columnWidths' in payload) {
                Object.assign(draft, payload.columnWidths);
            }
            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
